import { Component } from '@angular/core';
import { AgFilterComponent } from "ag-grid-angular";
import { IDoesFilterPassParams, IFilterParams } from "ag-grid-community";
import { AccountStatus } from '../models';

@Component({
    selector: 'account-status-component',
    template: `
        <div class="p-1" *ngIf="accountStatuses.length > 0">
            <div class="mb-2 d-grid gap-2">
                <button type="button" class="btn btn-sm btn-uiowa-dark btn-block" (click)="selectAll()">
                    <fa-icon [icon]="['fas', 'check-square']"></fa-icon> Select All
                </button>
                <button type="button" class="btn btn-sm btn-uiowa-dark btn-block" (click)="deselectAll()">
                    <fa-icon [icon]="['fas', 'square']"></fa-icon> Deselect All
                </button>
            </div>
            <div *ngFor="let accountStatus of accountStatuses">
                <div class="form-check mb-0">
                    <input type="checkbox" class="form-check-input" id="{{accountStatus.key}}" [checked]="isChecked(accountStatus.key)" (change)="toggleAccountStatusSelection(accountStatus.key)">
                    <label class="form-check-label" for="{{accountStatus.key}}">{{accountStatus.value}}</label>
                </div>
            </div>
        </div>
   `
})
export class AccountStatusFilter implements AgFilterComponent {
    params: IFilterParams;
    accountStatuses: { key: AccountStatus, value: string }[] = [
        { key: AccountStatus.Inactive, value: "Inactive" },
        { key: AccountStatus.Draft, value: "Draft" },
        { key: AccountStatus.Routing, value: "Routing" },
        { key: AccountStatus.Void, value: "Void" },
        { key: AccountStatus.Complete, value: "Complete" },
        { key: AccountStatus.Finalized, value: "Finalized" }
    ];
    selectedAccountStatuses: AccountStatus[] = [];

    agInit(params: IFilterParams): void {
        this.params = params;
        this.accountStatuses.forEach((accountStatus) => {
            this.selectedAccountStatuses.push(accountStatus.key);
        });
    }

    isFilterActive(): boolean {
        return true;
    }

    doesFilterPass(params: IDoesFilterPassParams): boolean {
        return this.selectedAccountStatuses.indexOf(params.data.status) !== -1;
    }

    getModel() {
    }

    setModel(model: any) {
    }

    isChecked(accountStatus: AccountStatus) {
        return this.selectedAccountStatuses.indexOf(accountStatus) !== -1;
    }

    toggleAccountStatusSelection(accountStatus: AccountStatus) {
        var index = this.selectedAccountStatuses.indexOf(accountStatus);
        if (index === -1) {
            this.selectedAccountStatuses.push(accountStatus);
        } else {
            this.selectedAccountStatuses.splice(index, 1);
        }
        this.params.filterChangedCallback();
    }

    selectAll() {
        this.deselectAll();
        this.accountStatuses.forEach((accountStatus) => {
            this.selectedAccountStatuses.push(accountStatus.key);
        });
        this.params.filterChangedCallback();
    }

    deselectAll() {
        this.selectedAccountStatuses = [];
        this.params.filterChangedCallback();
    }
}